import React from 'react'
import { SelectProps } from 'antd'
import EntitySelect from '../../../shared/components/EntitySelect'
import { useCustomers } from '../queries/useCtxCustomers'

interface CustomerSelectProps extends Omit<SelectProps<string>, 'options'> {
  companyId?: string
  // Customer ids to hide (e.g. already picked elsewhere).
  excludeValues?: string[]
}

/**
 * Select over a company's customers. Fetches its own data; shows "Ladataan…" instead of the raw id
 * while the list loads, and "Poistettu" if the selected customer no longer exists.
 */
const CustomerSelect: React.FC<CustomerSelectProps> = ({ companyId, excludeValues, ...selectProps }) => {
  const { data: customers = [], isLoading } = useCustomers(companyId)

  return <EntitySelect entities={customers} loading={isLoading} excludeValues={excludeValues} {...selectProps} />
}

export default CustomerSelect
